import React from 'react';

import { Modal } from 'src/components';
import './biz-wallet-pro-modal.scss';

export default function BizWalletProModal(props: {
  show: boolean;
  totalDevices: number;
  isVodapayChannel: boolean;
  onDoneButtonClickVodpayChannel: () => void;
  onConfirmButtonClickAddDirector: () => void;
  onDeclineButtonClickAddDirector: () => void;
}) {
  return (
    <Modal
      modalStyle="BizWalletProModal"
      show={props.show}
      cardStyle="resolve-modal-card"
      header={() => (
        <p className="resolve-modal-head heading-four has-text-centered">
          Biz Wallet Pro unavailable
        </p>
      )}
      headerStyle="resolve-modal-card-head"
      body={() =>
        !props.isVodapayChannel ? (
          <p className="content-large-extra">
            Biz Wallet pro is only applicable for a single director company, adding an additional
            director will remove the product from your basket. Would you like to
            {props.totalDevices === 1 ? ' choose a new solution' : ' add another director'}?
          </p>
        ) : (
          <p className="content-large-extra">
            Biz Wallet pro is only applicable for a single director company
          </p>
        )
      }
      bodyStyle="resolve-modal-card-body has-text-centered"
      footer={() => (
        <div className="columns">
          {props.isVodapayChannel ? (
            <div className="column is-half">
              <button
                className={'button is-primary is-pulled-left'}
                automationid="Onboarding_Choose_Solution_Button_Reduce_Delivery_Quantity_Yes"
                onClick={props.onDoneButtonClickVodpayChannel}
              >
                Done
              </button>
            </div>
          ) : (
            <>
              <div className="column is-half">
                <button
                  className={'button is-pulled-left no-button'}
                  automationid="Onboarding_Your_Business_Ids_Biz_Wallet_Pro_Modal_Button_Confirm"
                  onClick={props.onConfirmButtonClickAddDirector}
                >
                  {props.totalDevices === 1 ? 'Choose new solution' : 'Add director'}
                </button>
              </div>
              <div className="column is-half">
                <button
                  className={'button is-primary is-pulled-right'}
                  automationid="Onboarding_Your_Business_Ids_Biz_Wallet_Pro_Modal_Button_Reject"
                  onClick={props.onDeclineButtonClickAddDirector}
                >
                  No, continue with application
                </button>
              </div>
            </>
          )}
        </div>
      )}
      footerStyle="resolve-modal-card-foot"
      backdropStyle="backdrop"
      modalProps={undefined}
      modalWrapper={undefined}
      modalWrapperProps={undefined}
    />
  );
}
